import request from '@/utils/request.js';

// 发票列表
export const listInvoice = (pageData, formData) => {
    return request.post(`/admin/invoice/${pageData.page}/${pageData.pageSize}`, formData);
}

// 发票详情
export const detailInvoice = (invoiceId) => {
    return request.get(`/admin/invoice/${invoiceId}`);
}

// 发票冲红
export const invoiceRed = (invoiceId) => {
    return request.put(`/admin/invoice/red/${invoiceId}`);
}